import React from 'react'
import styled from 'styled-components'
import PageNotFoundIcon from 'components/icons/NoInterview.png'

const Container = styled.div`
  font-size: 34px;
  margin: 80px auto;
  text-align: center;
  color: #aaa;
`

const PageNotFoundMsg = styled.div`
  font-size: 16px;
  text-align: center;
`
const PageNotFound = () => (
  <Container>
    "Page not found or you don't have access to this page!"
    <br />
    <br />
    <img src={PageNotFoundIcon} alt="Page Not Found" />
    <PageNotFoundMsg>Please check the URL or click on menus.</PageNotFoundMsg>
  </Container>
)

export default PageNotFound
